import get from 'lodash/get';
import toUpper from 'lodash/toUpper';
import { getGlobalData } from '../core/store';

export default function getConfig() {
  const user = getGlobalData('user');
  const company = get(user, 'company');
  const settings = getCompanySettings(company);

  return key => settings[key];
}

function getCompanySettings(company) {
  const settings = get(company, 'settings') || [];
  if (!company || !settings.length) return [];

  return settings.reduce((prev, setting) => {
    const newSetting = {
      [toUpper(get(setting, 'setting_key'))]: {
        value: JSON.parse(get(setting, 'value')),
        key: toUpper(get(setting, 'setting_key')),
        backend_key: get(setting, 'setting_key'),
        type: get(setting, 'type')
      }
    };
    return { ...prev, ...newSetting };
  }, {});
}
